import { render, staticRenderFns } from "./SalutationPicker.vue?vue&type=template&id=0d878d40&scoped=true&"
import script from "./SalutationPicker.vue?vue&type=script&lang=js&"
export * from "./SalutationPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d878d40",
  null
  
)

export default component.exports